module.exports = __webpack_public_path__ + "static/img/sorrow3.b1fb6964.png";